import { getContext } from '@fiverr-private/fiverr_context';
import { MIXPANEL_EVENT_PROPERTIES } from '../../constants';
import { Store } from '../types';

type ProcessedUserState = ReturnType<typeof getProcessedState>;

const getProcessedState = () => {
    const { userId } = getContext();

    return {
        [MIXPANEL_EVENT_PROPERTIES.USER_STATE]: userId ? 'Logged In' : 'Guest',
    };
};

export class UserStore implements Store<ProcessedUserState> {
    public getData = () => getProcessedState();
}
